import { render, staticRenderFns } from "./teacher-performance-report.vue?vue&type=template&id=79fcae48&scoped=true&"
import script from "./teacher-performance-report.vue?vue&type=script&lang=js&"
export * from "./teacher-performance-report.vue?vue&type=script&lang=js&"
import style0 from "./teacher-performance-report.vue?vue&type=style&index=0&id=79fcae48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fcae48",
  null
  
)

export default component.exports